import { IVideoCompliance } from "@shared/lib/types/drafting";

//
export const BRIEF_LIST_QUERY_KEY = ["briefs"];
export const LOOKUPS_QUERY_KEY = ["lookups"];
export const makeBriefInfluencerQueryKey = (
  briefId: string,
  status?: string
) => ["briefs", "influencers", briefId, status || ""];
export const makeBriefSingleInfluencerQueryKey = (
  briefId: string,
  influencerId: string
) => ["briefs", "influencers", briefId, influencerId];
export const makeBriefLookUpQueryKey = (
  briefId: string,
  socialMediaId: string
) => {
  return [...LOOKUPS_QUERY_KEY, briefId, socialMediaId];
};

export const BRIEF_PLANNINGS_LIST_QUERY_KEY = ["brief", "plannings"];
export const BRIEF_OPERATIONS_LIST_QUERY_KEY = ["brief", "operations"];
export const BRIEF_PRICINGS_LIST_QUERY_KEY = ["brief", "pricings"];
export const BRIEF_FACETS_QUERY_KEY = ["brief-facets"];
export const BRIEF_INFLUENCER_FACETS_QUERY_KEY = ["brief-influencer-facets"];
export const BRIEF_INFLUENCER_V2_PURCHASE_STATUS_QUERY_KEY = [
  "brief-influencers-v2-purchase-status",
];
export const BRIEF_LEDGER_QUERY_KEY = ["brief-ledger"];
export const BRIEF_LEDGER_FACETS_QUERY_KEY = ["brief-ledger", "facets"];
export const BRIEF_INVOICE_QUERY_KEY = ["brief-invoice"];
export const BRIEF_INVOICE_FACETS_QUERY_KEY = ["brief-invoice", "facets"];
export const BRIEF_LOT_FACETS_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "lot",
  "facets",
];

export const BRIEF_DATA_FIELDS_QUERY_KEY = ["brief", "data-fields"];
export const BRIEF_CAMPAIGN_DATA_FIELDS_QUERY_KEY = [
  "brief",
  "campaign-data-fields",
];

export const BRIEF_PAYMENT_QUERY_KEY = ["brief-payment"];
export const BRIEF_PAYMENT_FACETS_QUERY_KEY = ["brief-payment", "facets"];

export const BRIEF_TOTAL_AGGREGATION_QUERY_KEY = ["brief-total", "aggregation"];
export const BRIEF_PAYMENT_AGGREGATION_QUERY_KEY = [
  "brief-payment",
  "aggregation",
];
export const BRIEF_LEDGER_AGGREGATION_QUERY_KEY = [
  "brief-ledger",
  "aggregation",
];
export const BRIEF_INVOICE_AGGREGATION_QUERY_KEY = [
  "brief-invoice",
  "aggregation",
];

export const BRIEF_INFLUENCER_CONFIG_FACETS_QUERY_KEY = [
  "brief-influencer-config-facets",
];

export const BRIEF_INFLUENCER_V2_QUERY_KEY = ["brief-influencer-v2"];
export const BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY = [
  "brief-influencer-v2",
  "search",
];
export const BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY = [
  "brief-influencer-v2",
  "deliverable",
];
export const BRIEF_INFLUENCER_V2_PRE_CHECK_DELIVERABLES_QUERY_KEY = [
  "brief-influencer-v2",
  "pre-check-deliverables",
];

export const BRIEF_SUGGESTED_INFLUENCERS_QUERY_KEY = ["suggested-influencers"];

export const makeBriefInfluencerV2QueryKey = (influencerId: string) => [
  ...BRIEF_INFLUENCER_V2_QUERY_KEY,
  influencerId,
];

export const makeBriefDeliverableQueryKey = (deliverableId: string) => [
  ...BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY,
  deliverableId,
];
export const makeBriefDeliverablesQueryKey = (briefId: string) => [
  ...BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY,
  briefId,
];

export enum SORT_ORDER {
  ASCEND = "ASC",
  DESCEND = "DESC",
}

export const briefConst = {
  status: {
    Pending: "Pending",
    Active: "Active",
    Closed: "Closed",
  },
  planning: {
    status: {
      Pending: "Pending",
      Active: "Active",
      Closed: "Closed",
    },
  },
  pricing: {
    status: {
      Pending: "Pending",
      Active: "Active",
      Closed: "Closed",
    },
  },
  operations: {
    status: {
      Pending: "Pending",
      Active: "Active",
      Closed: "Closed",
    },
  },
};

export enum BriefInfluencerStage {
  Internal = "Internal",
  Deleted = "Deleted",
  Shared = "Shared",
}

export enum BreifInfluencerV2StatusEnum {
  // Suggested = "Suggested",
  Shortlisted = "Shortlisted",
  Pricing = "Pricing",
  Purchased = "Purchased",
  Deleted = "Deleted",
  All = "",
}

export const ACTIVE_PIPELINE_STATUSES: BreifInfluencerV2StatusEnum[] = [
  BreifInfluencerV2StatusEnum.Shortlisted,
  BreifInfluencerV2StatusEnum.Pricing,
  BreifInfluencerV2StatusEnum.Purchased,
];

export const BRIEF_INFLUENCER_V2_STATUS = {
  // [BreifInfluencerV2StatusEnum.Shortlisted]: {
  //   label: "Discovery",
  //   description: "Creators identified as campaign-fit",
  //   value: BreifInfluencerV2StatusEnum.Shortlisted,
  //   icon: (
  //     <img
  //       src={"/Discovery.svg"}
  //       alt="Discover Square"
  //       style={{ width: 14, height: 14 }}
  //     />
  //   ),
  // },
  All: {
    label: "All",
    description: "Includes creators in all stages",
    value: "",
    icon: (
      <img
        src={"/UserList.svg"}
        alt="User List"
        style={{ width: 14, height: 14 }}
      />
    ),
  },
  [BreifInfluencerV2StatusEnum.Pricing]: {
    label: "Offered",
    description: "Got or negotiating creator price",
    value: BreifInfluencerV2StatusEnum.Pricing,
    icon: (
      <img
        src={"/CallEnd.svg"}
        alt="Discover Square"
        style={{ width: 14, height: 14 }}
      />
    ),
  },
  [BreifInfluencerV2StatusEnum.Purchased]: {
    label: "Purchased",
    description: "Creator booked for the campaign",
    value: BreifInfluencerV2StatusEnum.Purchased,
    icon: (
      <img
        src={"/bitcoinReceipt.svg"}
        alt="Bitcoin Receipt"
        style={{ width: 14, height: 14 }}
      />
    ),
  },
};

export enum actionsEnum {
  BRAND_DECLINED = "Brand Declined",
  CREATOR_DECLINED = "Creator Declined",
  REQUEST_BRAND_NEGOTIATION = "Request Brand Negotiation",
  PURCHASE = "Purchase",
  DELETE = "Delete",
  SKIP_CONFIRMATION = "Skip Confirmation",
  CHANGE_CONTACT = "Change Contact",
  VIEW = "View",
}

export enum influencerActionsEnum {
  addInfluencerCommercial = "Add ",
  addNewInfluencerCommercial = "Add New",
  viewInfluencerCommercial = "View",
  resend = "Resend",
  negotiate = "Negotiate",
}

export enum nextActionToTakeEnum {
  CANNOT_PURCHASE = "Cannot-Purchase",
  SUCCESS = "Success",
  NON_PROFITABLE = "Cannot-Purchase-Not-Profitable-Deal",
}

export enum UploaderType {
  Operations = "Operations",
  AccountManager = "Account Manager",
  Influencer = "Influencer",
  Pricing = "Pricing",
  Brand = "Brand",
}

export enum BriefDeliverableStatusEnum {
  Pending = "Pending",
  Uploaded = "Uploaded",
  PendingApproval = "Pending-Approval",
  EditsRequested = "Edits-Requested",
  Completed = "Completed",
  Approved = "Approved",
}

export enum BriefDeliverableTaskTypeEnum {
  Brief = "Brief",
  Script = "Script",
  Draft = "Draft",
  Live = "Live",
  Others = "Others",
}

export enum BriefDeliverableTaskUploadTypeEnum {
  Image = "Image",
  Video = "Video",
  YoutubeLink = "YoutubeLink",
  // GoogleDocs = "GoogleDocs",
  MediaLink = "MediaLink",
}

export const BRIEF_CONFIG_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "config",
];

export const BRIEF_CONFIG_DELIVERABLE_FACETS_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "config",
  "deliverable",
  "facets",
];

export const BRIEF_SCRIPTING_QUERY_KEY = (scriptingId: string) => [
  "scripting",
  scriptingId,
];

export const BRIEF_DRAFTING_QUERY_KEY = (draftingId: string) => [
  "drafting",
  draftingId,
];
export const BRIEF_TASK_FORMS = (briefId: string) => [
  "brief",
  briefId,
  "task",
  "forms",
];

export const generateMediaAssetsKey = (data: IVideoCompliance) => [
  "media-assets",
  data.draftingId,
  data.draftingVersionId,
  data.mediaAssetId,
];

export const scriptingStatusConst = {
  Pending: "Pending",
  Success: "Success",
  Failed: "Failed",
};

export const generateScriptingComplianceKey = (scriptingId: string) => [
  "scripting-compliance",
  scriptingId,
];

export const BRIEF_NOTIFICATIONS_QUERY_KEY = (briefId: string) => [
  "brief",
  briefId,
  "notifications",
];
export const BRIEF_NOTIFICATION_QUERY_KEY = (
  briefId: string,
  notificationId: string
) => ["brief", briefId, "notifications", notificationId];

export const BRIEF_AI_OVERVIEW_QUERY_KEY = (
  briefId: string,
  overviewId: string
) => ["brief", briefId, "ai", "overview", overviewId];
